import React from "react";

const actionTypes = {
  signin: 0,
  order: 1,
  orgaCartOrder: 2,
  personCartOrder: 3
}

const AccountOrder = ({onSelect}) => {
  return (
    <>
      <div className="account-content px-4 px-sm-6">
        <div className="bordered">
          <div className="d-flex align-items-center pointer p-3" onClick={() => onSelect(actionTypes.orgaCartOrder)}>
            <div className="icon-container-lg">
              <img alt="file_direct" src="/images/organization.svg" height={18} width={18}/>
            </div>
            <div className="pe-3">
              <div className="font-size-16 font-weight-bold text-dark">Байгууллага</div>
              <div className="font-size-14 text-grey">Байгууллага дээр та карт захиалах бол энд дарж үргэлжлүүлнэ үү.</div>
            </div>
            <img className="p-3" alt="choose" src="/images/arrow_next.svg" />
          </div>
          <hr className="m-0"/>
          <div className="d-flex align-items-center pointer p-3" onClick={() => onSelect(actionTypes.personCartOrder)}>
            <div className="icon-container-lg">
              <img alt="file_direct" src="/images/person.svg" height={18} width={18}/>
            </div>
            <div className="pe-3">
              <div className="font-size-16 font-weight-bold text-dark">Хувь хүн</div>
              <div className="font-size-14 text-grey">Та хувь хүнээр карт захиалах бол энд дарж үргэлжлүүлнэ үү.</div>
            </div>
            <img className="p-3" alt="choose" src="/images/arrow_next.svg" />
          </div>
        </div>
      </div>
      <div style={{height: 77}}></div>
    </>
  )
}

export default AccountOrder;
